module.exports = __webpack_public_path__ + "phone-bf6549d2c9b3920079f7a9269dbbb688.svg";